import { ReactElement } from 'react';

import { Theme, useTheme, useMediaQuery, Box, Stack, Grid, Link, Typography } from '@mui/material';

import { brands, description } from './data';

import Container from '../../components/Container';

export default function Footer(): ReactElement {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        backgroundColor: '#1f1f1f',

        pt: 5
      }}>
      <Container>
        <Stack spacing={5}>
          <Grid
            item
            container
            direction='row'
            justifyContent={isSm ? 'center' : 'space-between'}
            alignItems='center'
            wrap='wrap'
            spacing={isSm ? 4 : 2}>
            {brands.map((brand) => (
              <Grid key={brand.label} item>
                <Link
                  href={brand.link}
                  sx={{
                    'transition': (theme: Theme) =>
                      `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut}`,

                    '&:hover': {
                      opacity: 0.4
                    }
                  }}>
                  <img alt={brand.label} src={brand.src} />
                </Link>
              </Grid>
            ))}
          </Grid>

          <Typography align='left' color='grey.200' variant='body2'>
            {description}
          </Typography>

          <Stack direction='column' spacing={2} sx={{ pb: 2 }}>
            {/* Border Top */}
            <Box
              sx={{
                //  Border
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'divider',

                //  Border Radius
                borderStartStartRadius: '2px',
                borderStartEndRadius: '2px',
                borderEndStartRadius: '2px',
                borderEndEndRadius: '2px'
              }}
            />

            <Typography align='center' color='grey.200' variant='body1'>
              © 2021 Amazing Gaming. All Rights Reserved.
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
